export const UNIFORM_PARAM_PREFIX = `v_POLY_param_`;
export const UNIFORM_TEXTURE_PREFIX = `v_POLY_texture_`;
